<template>
  <div id="allpack" class="relative border-2 border-blue-900">
    <div v-if="showPackModal" class="w-screen h-screen absolute flex justify-center items-center z-50 left-1/2 top-0 transform -translate-x-1/2 bg-blacks">
      <div class="shadow-md rounded-sm myModal bg-gray-50 relatives">
        <button class="py-2 px-3 closebutton text-red-500 float-right" @click="closeAllPack()">Fermer</button>
        <p class="text-xl font-bold mb-4 mx-auto w-1/2 text-center">Listes des packs disponibles</p>

        <section class="dark:bg-slate-800">
          <div class="text-center">
            <!-- <a @click="closeAllPack()" class="sticky float-left  mt-3 mr-3" href="javascript:;">
              <svg class="w-8 h-8 text-slate-400" width="800px" height="800px" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g id="Menu / Close_LG">
                  <path id="Vector" d="M21 21L12 12M12 12L3 3M12 12L21.0001 3M12 12L3 21.0001" stroke="#000000"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
            </a> -->

            <div class="grid grid-cols-1">
              <div class="relative transition-all duration-500 ease-in-out">
                <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px] overflow-scroll">
                  <div v-for="pack in tableauPack" class="group mb-3 shadow-sm relative rounded-md overflow-hidden hover:shadow-xl dark:hover:shadow-gray-700 bg-white dark:bg-slate-900 text-center transition-all duration-500 ease-in-out h-fit hover:scale-105">
                    <span v-if="pack.promotion.pourcentage !== 0" class="absolute -right-12 -top-[8px] rotate-[45deg] w-44 h-20 pt-6 px-2 pb-0 flex items-center justify-center text-white bg-amber-500 font-semibold text-sm">
                      Remise de <br />
                      {{ pack.promotion.pourcentage }} %
                    </span>
                    <div class="p-6 py-8 border-b border-gray-100 dark:border-gray-700">
                      <h5 class="text-lg font-semibold uppercase">{{ pack.nom }}</h5>
                      <p class="text-slate-400 mt-4">{{ pack.description }}</p>
                    </div>

                    <div class="p-6 hosting-price">
                      <ul class="inline-block flex-wrap justify-center text-center p-1 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-full" id="myTabone" data-tabs-toggle="#StarterContent" role="tablist">
                        <li role="presentation" class="inline-block">
                          <button class="px-4 py-1 text-sm font-semibold rounded-full w-full transition-all duration-500 ease-in-out text-blue-900 bg-bsd-700" id="start-month-tab" data-tabs-target="#start-month" type="button" role="tab" aria-controls="start-month" aria-selected="true">{{ Month.monthly }}</button>
                        </li>
                        <li role="presentation" class="inline-block">
                          <button class="px-4 py-1 text-sm font-semibold rounded-full w-full transition-all duration-500 ease-in-out" id="start-year-tab" data-tabs-target="#start-year" type="button" role="tab" aria-controls="start-year" aria-selected="false">{{ Month.yearly }}</button>
                        </li>
                      </ul>

                      <div id="StarterContent" class="mt-6">
                        <div class="" id="start-month" role="tabpanel" aria-labelledby="start-month-tab">
                          <div class="flex justify-center">
                            <span class="text-sm text-slate-400 font-semibold">{{ Devises.af }}</span>
                            <span class="text-3xl font-semibold mx-1">{{ pack.prix }}</span>
                            <span class="text-sm text-slate-400 font-semibold self-end">/{{ Month.month }}</span>
                          </div>
                        </div>
                        <div class="hidden" id="start-year" role="tabpanel" aria-labelledby="start-year-tab">
                          <div class="flex justify-center">
                            <span class="text-sm text-slate-400 font-semibold"></span>
                            <span class="text-3xl font-semibold mx-1">15.99</span>
                            <span class="text-sm text-slate-400 font-semibold self-end">/{{ Month.year }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="mt-6">
                        <button @click="goToPayment(pack.id)" class="btn bg-bsd-700/5 hover:bg-bsd-700 border-bsd--blue-700/10 hover:border-bsd--blue-700 text-bsd-700 hover:text-black rounded-md">{{ DataBtn.cart }}</button>
                      </div>
                    </div>
                    <div class="py-3 px-2 bg-gray-50 dark:bg-slate-800">
                      <p class="text-black mb-0">
                        <b class="text-black dark:text-white">{{ pack1.texte }}</b>
                      </p>
                    </div>

                    <div class="h-40 p-6 border-b border-gray-100 dark:border-gray-700 text-left">
                      <ul class="list-none">
                        <li v-for="contenu in pack1.contenu" class="text-slate-400 my-1">
                          <i class="uil uil-check mr-2 text-emerald-600"></i> <b class="text-black dark:text-white"> {{ contenu.qut }} </b> {{ contenu.type }} pour {{ contenu.mois }} mois
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import GrilleTarifaireService from "@/services/modules/grilleTarifaire.service";
import PackService from "@/services/modules/pack.service";

export default {
  name: "Pricing",
  data() {
    return {
      Devises: {
        af: "XOF",
        ac: "XAF",
        e: "€",
        d: "$",
      },
      showPackModal: false,
      DataBtn: {
        cart: "Je prends ce pack",
      },
      Month: {
        monthly: "Mensuel",
        month: "Mois",
        yearly: "Annuel",
        year: "An",
      },
      Pack: {
        nameFirst: "QR LINK",
        nameSecond: "Comptoir",
        nameThird: "Stand Touch",
      },
      pack1: {
        id: "",
        nom: "",
        description: [],
        prix: "",
        contenu: [],
        promotion: {},
        texte: "",
      },
      pack2: {
        id: "",
        nom: "",
        description: [],
        prix: "",
        contenu: [],
        promotion: {},
        texte: "",
      },
      pack3: {
        id: "",
        nom: "",
        description: [],
        prix: "",
        contenu: [],
        promotion: {},
        texte: "",
      },
      Price: {
        monthPrice: 35500,
        yearPrice: 42500,
      },
      tableauPack: [],
    };
  },

  mounted() {
    // this.topFunction()
    //document.getElementById("myDIV").style.overflow = "scroll";

    this.getGrilleTarifaire();

    this.getPack();
  },
  methods: {
    getGrilleTarifaire() {
      GrilleTarifaireService.get()
        .then((response) => {
          let tabGrille = response.data.data;
        })
        .catch((e) => {});
    },

    getPack() {
      PackService.get()
        .then((response) => {
          let tabPack = response.data.data;

          this.tableauPack = tabPack;

          this.pack1.nom = tabPack[0].nom;
          this.pack1.prix = tabPack[0].montant;
          this.pack1.description = tabPack[0].description;
          this.pack1.contenu = tabPack[0].contenue;
          this.pack1.id = tabPack[0].id;
          this.pack1.promotion = tabPack[0].promotion;
          this.pack1.texte = tabPack[0].texte;

          this.pack2.nom = tabPack[1].nom;
          this.pack2.prix = tabPack[1].montant;
          this.pack2.description = tabPack[1].description;
          this.pack2.contenu = tabPack[1].contenue;
          this.pack2.id = tabPack[1].id;
          this.pack2.promotion = tabPack[1].promotion;
          this.pack2.texte = tabPack[1].texte;

          this.pack3.nom = tabPack[2].nom;
          this.pack3.prix = tabPack[2].montant;
          this.pack3.description = tabPack[2].description;
          this.pack3.contenu = tabPack[2].contenue;
          this.pack3.id = tabPack[2].id;
          this.pack3.promotion = tabPack[2].promotion;
          this.pack3.texte = tabPack[2].texte;
        })
        .catch((e) => {});
    },
    goToPayment(id) {
      //document.getElementById("myDIV").style.overflow = "scroll";
      this.$router.push({ name: "Paiement", params: { id: id } });
    },
    showAllPack() {
      document.getElementById("allpack").scrollIntoView();
      this.showPackModal = true;
      // document.getElementById("myDIV").style.overflow = "hidden";
    },
    closeAllPack() {
      // document.getElementById("myDIV").style.overflow = "scroll";
      this.showPackModal = false;
    },
    topFunction() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.bg-blacks {
  background-color: rgba(0, 0, 0, 0.471);
}

.customModal {
  /* height: 500px; */
  overflow: scroll;
}

.relatives {
  width: 90%;
  padding: 3%;
  height: 75%;
  overflow-y: scroll;
}

.closebutton {
  background: rgba(255, 0, 0, 0.76);
  color: white;
  border-radius: 5px;
  float: right;
  margin-top: -20px;
}
</style>
